export const progressStages = [
  {
    value: 'CLASSIFIED',
    label: 'Classified',
  },
  {
    value: 'PARSED',
    label: 'Parsed',
  },
  {
    value: 'DONE',
    label: 'Done',
  },
];
